import React from "react";
import { useDrag } from "react-dnd";

import BidEvent from "./BidEvent";
import FieldSettings from "./FieldSettings";
import JobEvent from "./JobEvent";
import DeliveryEvent from "./DeliveryEvent";
import AppointmentEvent from "./AppointmentEvent";

export const DraggableType = "event";

const findComponent = (eventType) => {
  switch (eventType) {
    case "bid":
      return BidEvent;
    case "job":
      return JobEvent;
    case "purchaseOrder":
      return DeliveryEvent;
    case "appointment":
      return AppointmentEvent;

    default:
      return null;
  }
};

const getEventColor = (event, eventType) => {
  if (eventType === "job" && event && event.color) {
    return event.color;
  }

  if (eventType === "bid") {
    return event.bid?.color || null;
  }

  if (eventType === "purchaseOrder") {
    return event.purchaseOrder?.color || null;
  }

  if (eventType === "appointment") {
    return event.appointment?.color || null;
  }

  return null;
};

const Event = ({ eventType, fields, event, showBorderLeft, ...props }) => {
  const [, drag] = useDrag({
    item: { eventId: props.eventId, event: event, type: DraggableType },
  });

  const EventComponent = findComponent(eventType);
  if (!EventComponent) {
    return null;
  }

  const color = getEventColor(event, eventType);

  const containerStyle =
    showBorderLeft && color
      ? {
          borderLeft: `4px solid ${color}`,
        }
      : {};

  return (
    <div ref={drag} style={containerStyle}>
      <FieldSettings.Provider value={fields}>
        <EventComponent {...props} event={event} />
      </FieldSettings.Provider>
    </div>
  );
};

export default Event;
